import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
let rout = {};
rout = {
    mode: 'hash',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [{
            path: '/',
            redirect: '/Main',
        },
        {
            path: '/',
            component: r => require.ensure([], () => r(require('../components/Home.vue'))),
            meta: {
                title: '自述文件'
            },
            children: [{
                    path: '/Main',
                    component: r => require.ensure([], () => r(require('../components/Main.vue'))),
                    name: "Main",
                    meta: {
                        title: '系统主页'
                    },
                },
                {
                    path: '/Download',
                    component: r => require.ensure([], () => r(require('../components/Download.vue'))),
                    name: "Download",
                    meta: {
                        title: '下载安装',
                    },
                },
                {
                    path: '/Directions',
                    component: r => require.ensure([], () => r(require('../components/Directions.vue'))),
                    name: "Directions",
                    meta: {
                        title: '使用说明',
                    },
                },
                {
                    path: '/QA',
                    component: r => require.ensure([], () => r(require('../components/QA.vue'))),
                    name: "QA",
                    meta: {
                        title: '常见问题',
                    },
                },
                {
                    path: '/ChangeLog',
                    component: r => require.ensure([], () => r(require('../components/changeLog.vue'))),
                    name: "ChangeLog",
                    meta: {
                        title: '更新日志',
                    },
                },
                {
                    path: '/privacy',
                    component: r => require.ensure([], () => r(require('../components/privacy.vue'))),
                    name: "privacy",
                    meta: {
                        title: '隐私协议',
                    },
                },
                {
                    path: '/404',
                    component: r => require.ensure([], () => r(require('../components/404.vue'))),
                    meta: {
                        title: '404'
                    }
                },
            ]
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
}
export default new Router(rout);